module.exports = __webpack_public_path__ + "static/img/yxt2_s.f46fba0a.png";